import { polyfill } from "es6-promise";
import axios from "axios";

polyfill();



const baseURL = window.location.hostname.toLowerCase().includes("localhost")
  ? "https://mybigycause.bags4mycause.com/api"
  : "./api";

export default axios.create({ baseURL });
